import React from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import Page404 from "go-app/components/Page404/Page404";
import AdminNavigation from "./components/AdminNavigation";
import AdminAccessPage from "./pages/AccessList";
import AdminAccessReportPage from "./pages/AccessReport/pages/Index";
import AdminAppVersionsPage from "./pages/AppVersions";
import AdminAppsPage from "./pages/Apps";
import AdminReportsComboPage from "./pages/Combo";
import AdminCompaniesReportPage from "./pages/CompaniesReport/pages/Index";
import CrashReportsPage from "./pages/CrashReports";
import AdminCustomFieldsPage from "./pages/CustomFields";
import AdminDashboardPage from "./pages/Dashboard";
import AdminDeviceReportPage from "./pages/DevicesReport";
import FileLogsPage from "./pages/FileLogs";
import AdminGoLauncherPage from "./pages/GoLauncher";
import AdminLoansPage from "./pages/Loans";
import AdminOrganizationFeatureReportPage from "./pages/OrganizationFeatureReport/pages/Index";
import AdminOrganizationFeatureUsageReportPage from "./pages/OrganizationFeatureReport/pages/Usage";
import AdminOrganizationReportPage from "./pages/OrganizationReport";
import AdminOrganizationsPage from "./pages/Organizations";
import AdminPartnerReportPage from "./pages/PartnerReport";
import AdminPartnersPage from "./pages/Partners";
import AdminPartnersPayoutInvoicesPage from "./pages/PartnersPayoutInvoices";
import AdminPayoffPage from "./pages/Payoffs";
import AdminTerminalsPage from "./pages/Terminals";
import AdminTerminalReportPage from "./pages/TerminalsReport";
import AdminToolsPage from "./pages/Tools";
import AdminTransactionsPage from "./pages/Transactions";
import AdminTransactionsReportPage from "./pages/TransactionsReport/pages/Index";
import AdminUsersPage from "./pages/Users";

const AdminConfigurationPage = (props: RouteComponentProps) => {
	return (
		<>
			<AdminNavigation match={props.match} history={props.history} location={props.location} />
			<Switch>
				<Route exact path={`${props.match.url}/`} component={AdminDashboardPage} />
				<Route path={`${props.match.url}/app_versions`} component={AdminAppVersionsPage} />
				<Route path={`${props.match.url}/apps`} component={AdminAppsPage} />
				<Route path={`${props.match.url}/organizations`} component={AdminOrganizationsPage} />
				<Route path={`${props.match.url}/users`} component={AdminUsersPage} />
				<Route path={`${props.match.url}/partners`} component={AdminPartnersPage} />
				<Route path={`${props.match.url}/tools`} component={AdminToolsPage} />
				<Route path={`${props.match.url}/crash_reports`} component={CrashReportsPage} />
				<Route path={`${props.match.url}/file_logs`} component={FileLogsPage} />
				<Route path={`${props.match.url}/custom_fields`} component={AdminCustomFieldsPage} />
				<Route path={`${props.match.url}/loans`} component={AdminLoansPage} />
				<Route path={`${props.match.url}/terminals`} component={AdminTerminalsPage} />
				<Route path={`${props.match.url}/terminals_report`} component={AdminTerminalReportPage} />
				<Route path={`${props.match.url}/devices_report`} component={AdminDeviceReportPage} />
				<Route path={`${props.match.url}/payoff`} component={AdminPayoffPage} />
				<Route path={`${props.match.url}/partner_report`} component={AdminPartnerReportPage} />
				<Route
					path={`${props.match.url}/partner_payout_invoices`}
					component={AdminPartnersPayoutInvoicesPage}
				/>
				<Route path={`${props.match.url}/organization_report`} component={AdminOrganizationReportPage} />
				<Route path={`${props.match.url}/companies_report`} component={AdminCompaniesReportPage} />
				<Route path={`${props.match.url}/transactions_report`} component={AdminTransactionsReportPage} />
				<Route
					path={`${props.match.url}/organization_feature_usage_report`}
					component={AdminOrganizationFeatureUsageReportPage}
				/>
				<Route
					path={`${props.match.url}/organization_feature_report`}
					component={AdminOrganizationFeatureReportPage}
				/>
				<Route path={`${props.match.url}/accesses`} component={AdminAccessPage} />
				<Route path={`${props.match.url}/accesses_report`} component={AdminAccessReportPage} />
				<Route path={`${props.match.url}/transactions`} component={AdminTransactionsPage} />
				<Route path={`${props.match.url}/go_launcher`} component={AdminGoLauncherPage} />
				<Redirect from={props.match.url} exact to={`${props.match.url}/`} />
				<Route component={Page404} />
			</Switch>
		</>
	);
};

export default AdminConfigurationPage;
